import ReactGA from "react-ga";
import { configureEnvironment } from "../../config/env";
import TagManager from "react-gtm-module";

export const inicializarAnalytics = (gtmEmpresa: string) => {
  if (gtmEmpresa && !window.location.hostname.includes("localhost")) {
    const tagManagerArgs = {
      gtmId: gtmEmpresa
    };

    TagManager.initialize(tagManagerArgs);
  }

  if (configureEnvironment().REACT_APP_CODIGO_GOOGLE_ANALYTICS) {
    ReactGA.initialize(configureEnvironment().REACT_APP_CODIGO_GOOGLE_ANALYTICS, {
      titleCase: false
    });
  }
};

export const cadastrarEvento = (evento: string, label: any, categoria: string | null = null) => {
  if (configureEnvironment().REACT_APP_CODIGO_GOOGLE_ANALYTICS) {
    ReactGA.event({
      category: categoria || "Help Exames",
      action: evento,
      label: String(label),
      value: 1
    });
  }
};
